import classnames from 'classnames';
import { getVideoIframeUrl } from 'app/utilities/youtube';
import PropTypes from 'prop-types';
import React from 'react';

const Video = (props) => {
    const { title, credit, video_url: videoUrl, theme_colour: theme } = props.data;

    const videoBlockClass = classnames('video-content-block', 'blocks', {
        'plum': theme === 'plum',
        'coral': theme === 'coral',
        'navy': theme === 'navy'
    });

    return (
        <section className={videoBlockClass}>
            <div className="meta">
                <h3 className="meta-title">{title}</h3>
                <h6 className="meta-credit">{credit}</h6>
            </div>
            <div className="video-content-block-inner || constrain-width no-pad || preserve-aspect-ratio video">
                <div className="preserve-aspect-ratio-media">
                    <iframe
                        title={title}
                        className="video"
                        src={getVideoIframeUrl(videoUrl)}
                        allowFullScreen={true}
                    />
                </div>
            </div>
        </section>
    );
};

Video.propTypes = {
    data: PropTypes.object.isRequired
};

export default Video;
